import React from 'react';
// import { CheckboxChangeEvent } from 'antd/es/checkbox';
// import { Checkbox } from 'antd';

import { CommonTnc } from '../CommonTncLI';

export const AgreementCheckboxLI = () => {
  return <CommonTnc />;
};
